<template>
  <div class="group-hover:scale-110 transition-transform cursor-pointer">
    <img v-if="row.backgroundImage" :src="row.backgroundImage" class="size-10 object-cover rounded-md">
    <div v-else class="size-10 rounded-md" :style="backgroundStyle" />
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  row: {
    type: Object,
    default: () => {}
  }
});

const backgroundStyle = computed(() => {
  const style = {};

  if (props.row.backgroundColor?.includes('gradient')) {
    style.backgroundImage = props.row.backgroundColor;
  } else if (props.row.backgroundColor) {
    style.backgroundColor = props.row.backgroundColor;
  }

  return style;
});
</script>
